import { getElasticClient, indexReview } from './index';
import { addDataElastic, updateDataElastic } from './elasticCommon';

const elasticClient = getElasticClient();

const createReviewIndex = function() {
  // don't create if already created
  return new Promise((resolve, reject) => {
    elasticClient.indices.exists(
      {
        index: indexReview
      },
      (error, exists) => {
        if (error) {
          console.error(`Error when create index:${indexReview}`);
        }
        if (exists) {
          console.log(`Index ${indexReview} already exists`);
          resolve(exists);
        } else {
          elasticClient.indices.create(
            {
              index: indexReview,
              body: {
                mappings: {
                  _doc: {
                    properties: {}
                  }
                }
              }
            },
            (error, result) => {
              console.log(result);
              if (!error) {
                resolve(result);
              } else {
                reject(error);
              }
            }
          );
        }
      }
    );
  });
};

/**
 * Add review to elastic search
 * @param {*} review
 * example review input
 * {
 *   id: 1,
 *   reviewType: 0,
 *   star: 4,
 *   comment: "青森県",
 *   sendAddress: "0x24c5CC6E09C71F791A19da5BB1e581BDD42c8d7B",
 *   recipientAddress: "0x95b60252b7a33bca2f6f122e3ae646de60c51eaa",
 *   createdAt: 123456,
 *   updatedAt: 456984
 * }
 */

const elasticAddreview = async function(review, token) {
  console.log('Start add to elastic search:', review);
  return await addDataElastic({
    index: indexReview,
    type: '_doc',
    data: review,
    token: token
  });
};

const elasticUpdateReview = async function(id, dataUpdate, token) {
  return await updateDataElastic({
    index: indexReview,
    type: '_doc',
    id: id,
    dataUpdate,
    token: token
  });
};

const elasticSearchReview = async function({ query, offset, limit, sort }) {
  const rawResult = await elasticClient.search({
    index: indexReview,
    type: '_doc',
    body: {
      from: offset,
      size: limit,
      query,
      sort
    }
  });
  return {
    orders: rawResult.hits.hits.map(item => item._source),
    count: rawResult.hits.total
  };
};

export { createReviewIndex, elasticAddreview, elasticUpdateReview, elasticSearchReview };
